import { template as template_70ff734d7e1a426db5f38dc5ef2bf0bc } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
import { filterByIds, callWithMapped } from 'eflex/helpers';
export default class BiPanelUsers extends Component {
    @service
    intl;
    @service
    userRepo;
    @tracked
    isDisplayed = false;
    constructor(){
        super(...arguments);
        this.isDisplayed = this.args.userIds?.length > 0;
        this.args.initParam('userIds', this.args.userIds);
    }
    @action
    onChange(users) {
        this.args.updateParam('userIds', users);
    }
    get users() {
        return this.userRepo.users;
    }
    get selectedUsers() {
        return this.args.getParam('userIds');
    }
    get selectedUsersBadgeText() {
        return this.args.createSearchBadgeText('userIds', 'user', 'criteria.selectedUsers', 'userName', 'user');
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_70ff734d7e1a426db5f38dc5ef2bf0bc(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-users-criteria"
        @class="align-items-end"
        @form={{@form}}
        @label="users"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{isPresent this.selectedUsers}}
        ...attributes
      >
        <div class="input-group">
          <div class="col">
            <div class="row">
              <div class="col">
                <@form.element
                  class="user-select"
                  @controlType="power-select-multiple"
                  @value={{filterByIds this.users this.selectedUsers}}
                  @options={{this.users}}
                  @optionLabelPath="userName"
                  @onChange={{callWithMapped this.onChange "id"}}
                as |el|>
                  <el.control
                    class="sm"
                    @searchEnabled={{true}}
                    @searchField="userName"
                    @placeholder={{t "biPanel.users.placeholder"}}
                  />
                </@form.element>
              </div>
            </div>
          </div>
        </div>
      </FilterWrapper>
    </Portal>

    <Portal @target="search-badge-tags">
      <SearchTag
        @isDisplayed={{@userIds}}
        @text={{this.selectedUsersBadgeText}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
